import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiPartnerToken} from '../../models/api-partner-token';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class PartnerTokenService extends AbstractModelService<ApiPartnerToken> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-token', ApiPartnerToken);
  }

  regenerate(partnerToken: ApiPartnerToken): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post(this.routePath + '/' + partnerToken.id + '/regenerate').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
